import { useMemo } from 'react';
import { buildCharacterSheet } from '@character-creator/core';
import type { CharacterSheet } from '@character-creator/types';
import { useCharacterCreationStore } from '../stores/characterCreationStore';

/** Backward compat: 21 files import this name */
export type CharacterBenefits = CharacterSheet;

export function useCharacterBenefits(): CharacterSheet {
  const { draft } = useCharacterCreationStore();
  return useMemo(() => buildCharacterSheet(draft), [draft]);
}
